/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminPermissionOverviewResponse } from '../models/AdminPermissionOverviewResponse';
import type { AdminUserListResponse } from '../models/AdminUserListResponse';
import type { AdminUserUpdateRequest } from '../models/AdminUserUpdateRequest';
import type { features__auth__models__permissions__PermissionLevel } from '../models/features__auth__models__permissions__PermissionLevel';
import type { GrantCountryAccessRequest } from '../models/GrantCountryAccessRequest';
import type { GrantDataPermissionRequest } from '../models/GrantDataPermissionRequest';
import type { GrantValueChainAccessRequest } from '../models/GrantValueChainAccessRequest';
import type { PermissionGrantResponse } from '../models/PermissionGrantResponse';
import type { PermissionRevokeResponse } from '../models/PermissionRevokeResponse';
import type { UsersWithPermissionsListResponse } from '../models/UsersWithPermissionsListResponse';
import type { UserWithPermissionsItem } from '../models/UserWithPermissionsItem';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Admin Health Check
     * Admin health check endpoint to verify admin functionality.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * Admin system health status
     * @returns any Successful Response
     * @throws ApiError
     */
    public adminHealthCheckApiV1AdminHealthGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/health',
        });
    }
    /**
     * Admin Health Check
     * Admin health check endpoint to verify admin functionality.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * Admin system health status
     * @returns any Successful Response
     * @throws ApiError
     */
    public adminHealthCheckApiV1AdminHealthGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/health',
        });
    }
    /**
     * Get All Users
     * Get all users (admin only).
     *
     * Args:
     * skip: Number of users to skip
     * limit: Maximum number of users to return
     * search: Search term for name or email
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * AdminUserListResponse: List of users with their basic information
     * @param skip Number of users to skip
     * @param limit Number of users to return
     * @param search Search by name or email
     * @returns AdminUserListResponse Successful Response
     * @throws ApiError
     */
    public getAllUsersApiV1AdminUsersGet(
        skip?: number,
        limit: number = 100,
        search?: (string | null),
    ): CancelablePromise<AdminUserListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/users',
            query: {
                'skip': skip,
                'limit': limit,
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Users
     * Get all users (admin only).
     *
     * Args:
     * skip: Number of users to skip
     * limit: Maximum number of users to return
     * search: Search term for name or email
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * AdminUserListResponse: List of users with their basic information
     * @param skip Number of users to skip
     * @param limit Number of users to return
     * @param search Search by name or email
     * @returns AdminUserListResponse Successful Response
     * @throws ApiError
     */
    public getAllUsersApiV1AdminUsersGet1(
        skip?: number,
        limit: number = 100,
        search?: (string | null),
    ): CancelablePromise<AdminUserListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/users',
            query: {
                'skip': skip,
                'limit': limit,
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Users With Permissions
     * List users with value chain, country, data, and financial permissions (admin only).
     * @param skip Number of users to skip
     * @param limit Users per page
     * @param search Search by name, email, or company
     * @param isActive Filter by account active status (omit for all users)
     * @returns UsersWithPermissionsListResponse Successful Response
     * @throws ApiError
     */
    public getUsersWithPermissionsApiV1AdminUsersWithPermissionsGet(
        skip?: number,
        limit: number = 50,
        search?: (string | null),
        isActive?: (boolean | null),
    ): CancelablePromise<UsersWithPermissionsListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/users/with-permissions',
            query: {
                'skip': skip,
                'limit': limit,
                'search': search,
                'is_active': isActive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Users With Permissions
     * List users with value chain, country, data, and financial permissions (admin only).
     * @param skip Number of users to skip
     * @param limit Users per page
     * @param search Search by name, email, or company
     * @param isActive Filter by account active status (omit for all users)
     * @returns UsersWithPermissionsListResponse Successful Response
     * @throws ApiError
     */
    public getUsersWithPermissionsApiV1AdminUsersWithPermissionsGet1(
        skip?: number,
        limit: number = 50,
        search?: (string | null),
        isActive?: (boolean | null),
    ): CancelablePromise<UsersWithPermissionsListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/users/with-permissions',
            query: {
                'skip': skip,
                'limit': limit,
                'search': search,
                'is_active': isActive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Permissions Admin
     * Return a single user's full permission payload (admin only).
     * @param userId
     * @returns UserWithPermissionsItem Successful Response
     * @throws ApiError
     */
    public getUserPermissionsAdminApiV1AdminUsersUserIdPermissionsGet(
        userId: number,
    ): CancelablePromise<UserWithPermissionsItem> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/users/{user_id}/permissions',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Permissions Admin
     * Return a single user's full permission payload (admin only).
     * @param userId
     * @returns UserWithPermissionsItem Successful Response
     * @throws ApiError
     */
    public getUserPermissionsAdminApiV1AdminUsersUserIdPermissionsGet1(
        userId: number,
    ): CancelablePromise<UserWithPermissionsItem> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/users/{user_id}/permissions',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Permission Overview
     * Get permission overview for all users (admin only).
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * AdminPermissionOverviewResponse: Overview of all permissions
     * @returns AdminPermissionOverviewResponse Successful Response
     * @throws ApiError
     */
    public getPermissionOverviewApiV1AdminPermissionsOverviewGet(): CancelablePromise<AdminPermissionOverviewResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/overview',
        });
    }
    /**
     * Get Permission Overview
     * Get permission overview for all users (admin only).
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * AdminPermissionOverviewResponse: Overview of all permissions
     * @returns AdminPermissionOverviewResponse Successful Response
     * @throws ApiError
     */
    public getPermissionOverviewApiV1AdminPermissionsOverviewGet1(): CancelablePromise<AdminPermissionOverviewResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/overview',
        });
    }
    /**
     * Grant Value Chain Access
     * Grant value chain access to a user (admin only).
     *
     * Args:
     * request: Value chain access grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission grant
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantValueChainAccessApiV1AdminPermissionsValueChainsGrantPost(
        requestBody: GrantValueChainAccessRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/admin/permissions/value-chains/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Value Chain Access
     * Grant value chain access to a user (admin only).
     *
     * Args:
     * request: Value chain access grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission grant
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantValueChainAccessApiV1AdminPermissionsValueChainsGrantPost1(
        requestBody: GrantValueChainAccessRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/admin/permissions/value-chains/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Value Chain Permission
     * Update value chain permission status (admin only).
     *
     * Args:
     * permission_id: ID of the permission to update
     * is_active: Whether the permission should be active
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission update
     * @param permissionId
     * @param isActive Whether the permission is active
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public updateValueChainPermissionApiV1AdminPermissionsValueChainsPermissionIdPatch(
        permissionId: number,
        isActive: boolean,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/permissions/value-chains/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            query: {
                'is_active': isActive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Value Chain Permission
     * Update value chain permission status (admin only).
     *
     * Args:
     * permission_id: ID of the permission to update
     * is_active: Whether the permission should be active
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission update
     * @param permissionId
     * @param isActive Whether the permission is active
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public updateValueChainPermissionApiV1AdminPermissionsValueChainsPermissionIdPatch1(
        permissionId: number,
        isActive: boolean,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/permissions/value-chains/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            query: {
                'is_active': isActive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Value Chain Access
     * Revoke value chain access (admin only).
     *
     * Args:
     * permission_id: ID of the permission to revoke
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionRevokeResponse: Confirmation of permission revocation
     * @param permissionId
     * @returns PermissionRevokeResponse Successful Response
     * @throws ApiError
     */
    public revokeValueChainAccessApiV1AdminPermissionsValueChainsPermissionIdDelete(
        permissionId: number,
    ): CancelablePromise<PermissionRevokeResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/permissions/value-chains/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Value Chain Access
     * Revoke value chain access (admin only).
     *
     * Args:
     * permission_id: ID of the permission to revoke
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionRevokeResponse: Confirmation of permission revocation
     * @param permissionId
     * @returns PermissionRevokeResponse Successful Response
     * @throws ApiError
     */
    public revokeValueChainAccessApiV1AdminPermissionsValueChainsPermissionIdDelete1(
        permissionId: number,
    ): CancelablePromise<PermissionRevokeResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/permissions/value-chains/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Country Access
     * Grant country access to a user (admin only).
     *
     * Args:
     * request: Country access grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission grant
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantCountryAccessApiV1AdminPermissionsCountriesGrantPost(
        requestBody: GrantCountryAccessRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/admin/permissions/countries/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Country Access
     * Grant country access to a user (admin only).
     *
     * Args:
     * request: Country access grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission grant
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantCountryAccessApiV1AdminPermissionsCountriesGrantPost1(
        requestBody: GrantCountryAccessRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/admin/permissions/countries/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Country Permission
     * Update country permission status (admin only).
     *
     * Args:
     * permission_id: ID of the permission to update
     * is_active: Whether the permission should be active
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission update
     * @param permissionId
     * @param isActive Whether the permission is active
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public updateCountryPermissionApiV1AdminPermissionsCountriesPermissionIdPatch(
        permissionId: number,
        isActive: boolean,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/permissions/countries/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            query: {
                'is_active': isActive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Country Permission
     * Update country permission status (admin only).
     *
     * Args:
     * permission_id: ID of the permission to update
     * is_active: Whether the permission should be active
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission update
     * @param permissionId
     * @param isActive Whether the permission is active
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public updateCountryPermissionApiV1AdminPermissionsCountriesPermissionIdPatch1(
        permissionId: number,
        isActive: boolean,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/permissions/countries/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            query: {
                'is_active': isActive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Country Access
     * Revoke country access (admin only).
     *
     * Args:
     * permission_id: ID of the permission to revoke
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionRevokeResponse: Confirmation of permission revocation
     * @param permissionId
     * @returns PermissionRevokeResponse Successful Response
     * @throws ApiError
     */
    public revokeCountryAccessApiV1AdminPermissionsCountriesPermissionIdDelete(
        permissionId: number,
    ): CancelablePromise<PermissionRevokeResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/permissions/countries/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Country Access
     * Revoke country access (admin only).
     *
     * Args:
     * permission_id: ID of the permission to revoke
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionRevokeResponse: Confirmation of permission revocation
     * @param permissionId
     * @returns PermissionRevokeResponse Successful Response
     * @throws ApiError
     */
    public revokeCountryAccessApiV1AdminPermissionsCountriesPermissionIdDelete1(
        permissionId: number,
    ): CancelablePromise<PermissionRevokeResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/permissions/countries/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Data Permission
     * Grant data permission to a user (admin only).
     *
     * Args:
     * request: Data permission grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission grant
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantDataPermissionApiV1AdminPermissionsDataGrantPost(
        requestBody: GrantDataPermissionRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/admin/permissions/data/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Data Permission
     * Grant data permission to a user (admin only).
     *
     * Args:
     * request: Data permission grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission grant
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantDataPermissionApiV1AdminPermissionsDataGrantPost1(
        requestBody: GrantDataPermissionRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/admin/permissions/data/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Data Permission
     * Update data permission status (admin only).
     *
     * Args:
     * permission_id: ID of the permission to update
     * is_active: Whether the permission should be active
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission update
     * @param permissionId
     * @param isActive Whether the permission is active
     * @param totpCode 6-digit TOTP required when deactivating your own admin permission
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public updateDataPermissionApiV1AdminPermissionsDataPermissionIdPatch(
        permissionId: number,
        isActive: boolean,
        totpCode?: (string | null),
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/permissions/data/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            query: {
                'is_active': isActive,
                'totp_code': totpCode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Data Permission
     * Update data permission status (admin only).
     *
     * Args:
     * permission_id: ID of the permission to update
     * is_active: Whether the permission should be active
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Confirmation of permission update
     * @param permissionId
     * @param isActive Whether the permission is active
     * @param totpCode 6-digit TOTP required when deactivating your own admin permission
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public updateDataPermissionApiV1AdminPermissionsDataPermissionIdPatch1(
        permissionId: number,
        isActive: boolean,
        totpCode?: (string | null),
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/permissions/data/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            query: {
                'is_active': isActive,
                'totp_code': totpCode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Data Permission
     * Revoke data permission (admin only).
     *
     * Args:
     * permission_id: ID of the permission to revoke
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionRevokeResponse: Confirmation of permission revocation
     * @param permissionId
     * @returns PermissionRevokeResponse Successful Response
     * @throws ApiError
     */
    public revokeDataPermissionApiV1AdminPermissionsDataPermissionIdDelete(
        permissionId: number,
    ): CancelablePromise<PermissionRevokeResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/permissions/data/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Data Permission
     * Revoke data permission (admin only).
     *
     * Args:
     * permission_id: ID of the permission to revoke
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionRevokeResponse: Confirmation of permission revocation
     * @param permissionId
     * @returns PermissionRevokeResponse Successful Response
     * @throws ApiError
     */
    public revokeDataPermissionApiV1AdminPermissionsDataPermissionIdDelete1(
        permissionId: number,
    ): CancelablePromise<PermissionRevokeResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/permissions/data/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Value Chain Permissions
     * Get all value chain permissions (admin only).
     *
     * Args:
     * skip: Number of permissions to skip
     * limit: Maximum number of permissions to return
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * ValueChainListResponse: List of value chain permissions
     * @param skip Number of permissions to skip
     * @param limit Number of permissions to return
     * @param userId Filter by user ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllValueChainPermissionsApiV1AdminPermissionsValueChainsGet(
        skip?: number,
        limit: number = 100,
        userId?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/value-chains',
            query: {
                'skip': skip,
                'limit': limit,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Value Chain Permissions
     * Get all value chain permissions (admin only).
     *
     * Args:
     * skip: Number of permissions to skip
     * limit: Maximum number of permissions to return
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * ValueChainListResponse: List of value chain permissions
     * @param skip Number of permissions to skip
     * @param limit Number of permissions to return
     * @param userId Filter by user ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllValueChainPermissionsApiV1AdminPermissionsValueChainsGet1(
        skip?: number,
        limit: number = 100,
        userId?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/value-chains',
            query: {
                'skip': skip,
                'limit': limit,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Country Permissions
     * Get all country permissions (admin only).
     *
     * Args:
     * skip: Number of permissions to skip
     * limit: Maximum number of permissions to return
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * CountryListResponse: List of country permissions
     * @param skip Number of permissions to skip
     * @param limit Number of permissions to return
     * @param userId Filter by user ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllCountryPermissionsApiV1AdminPermissionsCountriesGet(
        skip?: number,
        limit: number = 100,
        userId?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/countries',
            query: {
                'skip': skip,
                'limit': limit,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Country Permissions
     * Get all country permissions (admin only).
     *
     * Args:
     * skip: Number of permissions to skip
     * limit: Maximum number of permissions to return
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * CountryListResponse: List of country permissions
     * @param skip Number of permissions to skip
     * @param limit Number of permissions to return
     * @param userId Filter by user ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllCountryPermissionsApiV1AdminPermissionsCountriesGet1(
        skip?: number,
        limit: number = 100,
        userId?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/countries',
            query: {
                'skip': skip,
                'limit': limit,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Data Permissions
     * Get all data permissions (admin only).
     *
     * Args:
     * skip: Number of permissions to skip
     * limit: Maximum number of permissions to return
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * DataPermissionListResponse: List of data permissions
     * @param skip Number of permissions to skip
     * @param limit Number of permissions to return
     * @param userId Filter by user ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllDataPermissionsApiV1AdminPermissionsDataGet(
        skip?: number,
        limit: number = 100,
        userId?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/data',
            query: {
                'skip': skip,
                'limit': limit,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Data Permissions
     * Get all data permissions (admin only).
     *
     * Args:
     * skip: Number of permissions to skip
     * limit: Maximum number of permissions to return
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * DataPermissionListResponse: List of data permissions
     * @param skip Number of permissions to skip
     * @param limit Number of permissions to return
     * @param userId Filter by user ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllDataPermissionsApiV1AdminPermissionsDataGet1(
        skip?: number,
        limit: number = 100,
        userId?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/data',
            query: {
                'skip': skip,
                'limit': limit,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Admin Value Chains
     * Get all available value chains from Neo4j graph database for admin management.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * List of value chains available for permission management
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminValueChainsApiV1AdminResourcesValueChainsGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/value-chains',
        });
    }
    /**
     * Get Admin Value Chains
     * Get all available value chains from Neo4j graph database for admin management.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * List of value chains available for permission management
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminValueChainsApiV1AdminResourcesValueChainsGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/value-chains',
        });
    }
    /**
     * Get Admin Countries
     * Get all available countries from company_addresses table for admin management.
     *
     * These countries represent where companies are located and are used for
     * company permission management. This does NOT affect the countries table
     * used for trade data.
     *
     * Args:
     * current_user: Current authenticated user
     * auth_db: Authentication database session
     *
     * Returns:
     * List of countries available for company permission management
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminCountriesApiV1AdminResourcesCountriesGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/countries',
        });
    }
    /**
     * Get Admin Countries
     * Get all available countries from company_addresses table for admin management.
     *
     * These countries represent where companies are located and are used for
     * company permission management. This does NOT affect the countries table
     * used for trade data.
     *
     * Args:
     * current_user: Current authenticated user
     * auth_db: Authentication database session
     *
     * Returns:
     * List of countries available for company permission management
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminCountriesApiV1AdminResourcesCountriesGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/countries',
        });
    }
    /**
     * Get Admin Graph Sources
     * Admin: Return distinct source_db values with counts from Neo4j.
     *
     * Mirrors /api/v1/graph/sources but scoped under admin resources.
     * @param refresh Bypass cache when set to 1
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminGraphSourcesApiV1AdminResourcesGraphSourcesGet(
        refresh?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/graph-sources',
            query: {
                'refresh': refresh,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Admin Graph Sources
     * Admin: Return distinct source_db values with counts from Neo4j.
     *
     * Mirrors /api/v1/graph/sources but scoped under admin resources.
     * @param refresh Bypass cache when set to 1
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminGraphSourcesApiV1AdminResourcesGraphSourcesGet1(
        refresh?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/graph-sources',
            query: {
                'refresh': refresh,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Admin Data Types
     * Get all available data types for admin management.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * List of data types available for permission management
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminDataTypesApiV1AdminResourcesDataTypesGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/data-types',
        });
    }
    /**
     * Get Admin Data Types
     * Get all available data types for admin management.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * List of data types available for permission management
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminDataTypesApiV1AdminResourcesDataTypesGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/data-types',
        });
    }
    /**
     * Update User Role
     * Update a user's role (admin only).
     *
     * Args:
     * user_id: ID of the user to update
     * role: New role for the user
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * dict: Success message and updated user info
     * @param userId
     * @param role New role for the user (user, admin, superuser)
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateUserRoleApiV1AdminUsersUserIdRolePatch(
        userId: number,
        role: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/users/{user_id}/role',
            path: {
                'user_id': userId,
            },
            query: {
                'role': role,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update User Role
     * Update a user's role (admin only).
     *
     * Args:
     * user_id: ID of the user to update
     * role: New role for the user
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * dict: Success message and updated user info
     * @param userId
     * @param role New role for the user (user, admin, superuser)
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateUserRoleApiV1AdminUsersUserIdRolePatch1(
        userId: number,
        role: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/users/{user_id}/role',
            path: {
                'user_id': userId,
            },
            query: {
                'role': role,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin Update User
     * Update admin-editable user fields (profile, active, verified, role).
     * @param userId
     * @param requestBody
     * @returns UserWithPermissionsItem Successful Response
     * @throws ApiError
     */
    public adminUpdateUserApiV1AdminUsersUserIdPatch(
        userId: number,
        requestBody: AdminUserUpdateRequest,
    ): CancelablePromise<UserWithPermissionsItem> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/users/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin Update User
     * Update admin-editable user fields (profile, active, verified, role).
     * @param userId
     * @param requestBody
     * @returns UserWithPermissionsItem Successful Response
     * @throws ApiError
     */
    public adminUpdateUserApiV1AdminUsersUserIdPatch1(
        userId: number,
        requestBody: AdminUserUpdateRequest,
    ): CancelablePromise<UserWithPermissionsItem> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/admin/users/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete User Account
     * Permanently delete a user and cascade-delete their auth permissions.
     *
     * Note:
     * - This is a hard delete from the auth database.
     * - Related rows (country/data/value_chain/financial permissions) use ondelete=CASCADE and will be removed.
     * - After deletion, the same email can be re-invited.
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteUserAccountApiV1AdminUsersUserIdDelete(
        userId: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete User Account
     * Permanently delete a user and cascade-delete their auth permissions.
     *
     * Note:
     * - This is a hard delete from the auth database.
     * - Related rows (country/data/value_chain/financial permissions) use ondelete=CASCADE and will be removed.
     * - After deletion, the same email can be re-invited.
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteUserAccountApiV1AdminUsersUserIdDelete1(
        userId: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Admin Financial Sources
     * Get all available financial data sources for admin management.
     *
     * Returns unique country-source combinations from the financial_info table.
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminFinancialSourcesApiV1AdminResourcesFinancialSourcesGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/financial-sources',
        });
    }
    /**
     * Get Admin Financial Sources
     * Get all available financial data sources for admin management.
     *
     * Returns unique country-source combinations from the financial_info table.
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAdminFinancialSourcesApiV1AdminResourcesFinancialSourcesGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/resources/financial-sources',
        });
    }
    /**
     * Grant Financial Data Access
     * Grant financial data access permission to a user (admin only).
     *
     * Permissions are granted for specific country-source combinations.
     * @param userId User ID
     * @param country Country name
     * @param source Data source
     * @param permissionLevel Permission level
     * @param notes Notes about the permission
     * @param expiresAt Expiration date
     * @returns any Successful Response
     * @throws ApiError
     */
    public grantFinancialDataAccessApiV1AdminPermissionsFinancialDataGrantPost(
        userId: number,
        country: string,
        source: string,
        permissionLevel: features__auth__models__permissions__PermissionLevel = 'read',
        notes?: (string | null),
        expiresAt?: (string | null),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/admin/permissions/financial-data/grant',
            query: {
                'user_id': userId,
                'country': country,
                'source': source,
                'permission_level': permissionLevel,
                'notes': notes,
                'expires_at': expiresAt,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Financial Data Access
     * Grant financial data access permission to a user (admin only).
     *
     * Permissions are granted for specific country-source combinations.
     * @param userId User ID
     * @param country Country name
     * @param source Data source
     * @param permissionLevel Permission level
     * @param notes Notes about the permission
     * @param expiresAt Expiration date
     * @returns any Successful Response
     * @throws ApiError
     */
    public grantFinancialDataAccessApiV1AdminPermissionsFinancialDataGrantPost1(
        userId: number,
        country: string,
        source: string,
        permissionLevel: features__auth__models__permissions__PermissionLevel = 'read',
        notes?: (string | null),
        expiresAt?: (string | null),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/admin/permissions/financial-data/grant',
            query: {
                'user_id': userId,
                'country': country,
                'source': source,
                'permission_level': permissionLevel,
                'notes': notes,
                'expires_at': expiresAt,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Financial Data Permissions
     * Get all financial data permissions for a specific user (admin only).
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public getUserFinancialDataPermissionsApiV1AdminPermissionsFinancialDataUserUserIdGet(
        userId: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/financial-data/user/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Financial Data Permissions
     * Get all financial data permissions for a specific user (admin only).
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public getUserFinancialDataPermissionsApiV1AdminPermissionsFinancialDataUserUserIdGet1(
        userId: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/financial-data/user/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Financial Data Permissions
     * Get financial data permissions across users (admin only, paginated).
     * @param skip Number of permissions to skip
     * @param limit Number of permissions to return
     * @param userId Filter by user ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllFinancialDataPermissionsApiV1AdminPermissionsFinancialDataGet(
        skip?: number,
        limit: number = 250,
        userId?: (number | null),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/financial-data',
            query: {
                'skip': skip,
                'limit': limit,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Financial Data Permissions
     * Get financial data permissions across users (admin only, paginated).
     * @param skip Number of permissions to skip
     * @param limit Number of permissions to return
     * @param userId Filter by user ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllFinancialDataPermissionsApiV1AdminPermissionsFinancialDataGet1(
        skip?: number,
        limit: number = 250,
        userId?: (number | null),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/admin/permissions/financial-data',
            query: {
                'skip': skip,
                'limit': limit,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Financial Data Permission
     * Revoke a financial data permission (admin only).
     * @param permissionId
     * @returns any Successful Response
     * @throws ApiError
     */
    public revokeFinancialDataPermissionApiV1AdminPermissionsFinancialDataPermissionIdDelete(
        permissionId: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/permissions/financial-data/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Financial Data Permission
     * Revoke a financial data permission (admin only).
     * @param permissionId
     * @returns any Successful Response
     * @throws ApiError
     */
    public revokeFinancialDataPermissionApiV1AdminPermissionsFinancialDataPermissionIdDelete1(
        permissionId: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/admin/permissions/financial-data/{permission_id}',
            path: {
                'permission_id': permissionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
